class VariantCopyChange extends HTMLElement {
  constructor() {
    super();
    this.handleMetafieldChange = this.handleMetafieldChange.bind(this);
  }

  connectedCallback() {
    document.addEventListener('test-variant-change', (e) => this.handleMetafieldChange(e))
  }

  handleMetafieldChange(event) {
    const selectedVariantId = event.detail || event.target.value;
    if (!selectedVariantId) {
      console.error('Selected Variant ID is undefined');
      return;
    }

    const allMetafields = this.querySelectorAll('.variants-metafields__item');

    allMetafields.forEach(metafield => {
      const isMatch = metafield.dataset.variantId == selectedVariantId;
      metafield.style.display = isMatch ? 'block' : 'none';
    });
  }
}

customElements.define('variant-copy-change', VariantCopyChange);